import { createFileRoute } from "@tanstack/react-router";

import { OrderList as OrderMain } from "@/features/office/orders/list";
import { orderListSearchSchema } from "@/features/office/orders/list/_configs/order-list-search-schema";
import { OrderWorkflowGate } from "@/features/shared/feature-gates/order-workflow-gate";

export const Route = createFileRoute("/office/orders/workflow")({
  validateSearch: orderListSearchSchema,
  component: () => (
    <OrderWorkflowGate>
      <OrderMain />
    </OrderWorkflowGate>
  ),
});
